import clsx from 'clsx';
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import DeleteIcon from '@/icons/DeleteIcon';
import SearchIcon from '@/icons/SearchIcon';
import './SearchField.less';

function SearchField({ value, placeholder, onBlur, onChange, onFocus }, fwdRef) {
    const [focused, setFocused] = useState(false);
    const ref = useRef();
    useImperativeHandle(fwdRef, () => ({ focus: () => ref.current.focus() }));
    const empty = !value;
    const text = value || '';

    function blur() {
        setFocused(false);
        if (onBlur) onBlur();
    }
    function change(e) {
        if (onChange) onChange(e.target.value);
    }
    function clear() {
        if (onChange) onChange('');
    }
    function focus() {
        setFocused(true);
        if (onFocus) onFocus();
    }

    return (
        <label className={clsx('search-field', { empty, focused })} data-atid="search-input-enter">
            <SearchIcon />
            <input
                ref={ref}
                type="search"
                autoComplete="off"
                value={text}
                placeholder={placeholder}
                onBlur={blur}
                onChange={change}
                onFocus={focus}
            />
            {empty ? null : (
                <span className="clear" onClick={clear} data-atid="search-input-delete">
                    <DeleteIcon />
                </span>
            )}
        </label>
    );
}
export default forwardRef(SearchField);
